import { Stack } from "@mui/material";

import { CoverageLines } from "../CoverageLines";
import { GeneralRfpData } from "../GeneralRfpData";
import { RumisRead } from "../RumisRead";

import type { RumiRun } from "../../types";

interface Props {
  run: RumiRun;
  onRerun: () => void;
}

/**
 * The Launchpad: what Rumi produced on an RFP, and what it could not finish.
 *
 * Read-only by decision. Every section hands off to the screen that can
 * change the data rather than editing in place, so this page reports a run
 * and never works one.
 */
const RumiLaunchpad = ({ run, onRerun }: Props): React.JSX.Element => (
  <Stack spacing={3}>
    <RumisRead
      narrative={run.narrative}
      meta={run.meta}
      atAGlance={run.atAGlance}
      stateCards={run.stateCards}
      onRerun={onRerun}
    />

    <Stack
      direction={{ xs: "column", lg: "row" }}
      spacing={3}
      alignItems="flex-start"
    >
      <Stack sx={{ flex: 1, width: "100%" }}>
        <GeneralRfpData sections={run.generalSections} />
      </Stack>
      <Stack sx={{ flex: 1, width: "100%" }}>
        <CoverageLines sections={run.coverageSections} />
      </Stack>
    </Stack>
  </Stack>
);

export { RumiLaunchpad };
export type { Props as RumiLaunchpadProps };
